import { Navigate, RouteObject } from 'react-router-dom'
import { AccessDeniedFallbackMessage } from './AccessDeniedFallbackMessage'

export const defaultRoutes: RouteObject[] = [
    { path: '', element: <AccessDeniedFallbackMessage /> },
    { path: '*', element: <Navigate to="/" />},
]
